<template>
  <div>
	
    <CRow>
      <CCol sm="12">
        <CCard>
          <!-- <CCardHeader>
            <strong>Raise Waste Request</strong>
          </CCardHeader> -->
          <CCardBody>
            
            <CRow class="mb-2 counterDiv">
              <CCol md="12"> 
                <div class="mt-1 mb-3">
                  <h4><strong>Date: 2020-08-10 to 2020-09-10</strong></h4>
                </div>
              </CCol>
              <CCol md="12" class="p-0 d-flex mb-4">
              <CCol md="6">
                <CCard class="m-0">
                    <CListGroup>
                      <CListGroupItem
                        class="flex-column align-items-start pl-0 pr-0"
                      >
                        <CCol md="12" class="d-flex p-0 mb-3"> 
                          <CCol md="6">
                            <div class="w-100">
                              <h5 class="mb-1">Customer Code</h5>
                              <p class="m-0 col-green fw-500">420001783</p>
                            </div>
                          </CCol>

                          <CCol md="6"> 
                            <div class="w-100">
                              <h5 class="mb-1">Customer Name</h5>
                              <p class="m-0 fw-500">John Doe</p>
                            </div>
                          </CCol>
                        </CCol>

                        <CCol md="12" class="d-flex p-0 mb-3"> 
                          <CCol md="6">
                            <div class="w-100">
                              <h5 class="mb-1">Waste Name</h5>
                              <p class="m-0 fw-500 col-fonts-grey">DISTILLATION RESIDUE-20.43-SD24B</p>
                            </div>
                          </CCol>

                          <CCol md="6"> 
                            <div class="w-100">
                              <h5 class="mb-1">Packaging Mode</h5>
                              <p class="m-0 fw-500 col-fonts-grey">Jumbo Bags</p>
                            </div>
                          </CCol>
                        </CCol>

                        <CCol md="12" class="d-flex mb-1"> 
                          <div class="w-100">
                            <h5 class="mb-1">Notification</h5>
                            <p class="m-0 fw-500 col-fonts-grey">Vehicle has been assigned for your request number 00019203. Details are as: John Doe</p>
                          </div>
                        </CCol>

                        <CCol md="12" class="d-flex"> 
                          <div class="w-100">
                             <span class="d-flex align-center col-yellow fw-500 justify-end"><CIcon name="cil-calendar" class="mr-1 h-20 w-20"/> 08 Sep 2020</span>
                          </div>
                        </CCol>

                      </CListGroupItem>
                    </CListGroup>
                </CCard>
              </CCol>

              <CCol md="6">
                <CCard class="m-0">
                    <CListGroup>
                      <CListGroupItem
                        class="flex-column align-items-start pl-0 pr-0"
                      >
                        <CCol md="12" class="d-flex p-0 mb-3"> 
                          <CCol md="6">
                            <div class="w-100">
                              <h5 class="mb-1">Customer Code</h5>
                              <p class="m-0 col-green fw-500">420001783</p>
                            </div>
                          </CCol>

                          <CCol md="6"> 
                            <div class="w-100">
                              <h5 class="mb-1">Customer Name</h5>
                              <p class="m-0 fw-500">John Doe</p>
                            </div>
                          </CCol>
                        </CCol>

                        <CCol md="12" class="d-flex p-0 mb-3"> 
                          <CCol md="6">
                            <div class="w-100">
                              <h5 class="mb-1">Waste Name</h5>
                              <p class="m-0 fw-500 col-fonts-grey">DISTILLATION RESIDUE-20.43-SD24B</p>
                            </div>
                          </CCol>

                          <CCol md="6"> 
                            <div class="w-100">
                              <h5 class="mb-1">Packaging Mode</h5>
                              <p class="m-0 fw-500 col-fonts-grey">Jumbo Bags</p>
                            </div>
                          </CCol>
                        </CCol>

                        <CCol md="12" class="d-flex"> 
                          <div class="w-100">
                            <h5 class="mb-1">Notification</h5>
                            <p class="m-0 fw-500 col-fonts-grey">Vehicle has been assigned for your request number 00019203. Details are as: John Doe</p>
                          </div>
                        </CCol>

                        <CCol md="12" class="d-flex"> 
                          <div class="w-100">
                             <span class="d-flex align-center col-yellow fw-500 justify-end"><CIcon name="cil-calendar" class="mr-1 h-20 w-20"/> 17 Aug 2020</span>
                          </div>
                        </CCol>

                      </CListGroupItem>
                    </CListGroup>
                </CCard>
              </CCol>
              </CCol>

              <CCol md="12" class="p-0 d-flex mb-4">
              <CCol md="6">
                <CCard class="m-0">
                    <CListGroup>
                      <CListGroupItem
                        class="flex-column align-items-start pl-0 pr-0"
                      >
                        <CCol md="12" class="d-flex p-0 mb-3"> 
                          <CCol md="6">
                            <div class="w-100">
                              <h5 class="mb-1">Customer Code</h5>
                              <p class="m-0 col-green fw-500">420001783</p>
                            </div>
                          </CCol>

                          <CCol md="6"> 
                            <div class="w-100">
                              <h5 class="mb-1">Customer Name</h5>
                              <p class="m-0 fw-500">John Doe</p>
                            </div>
                          </CCol>
                        </CCol>

                        <CCol md="12" class="d-flex p-0 mb-3"> 
                          <CCol md="6">
                            <div class="w-100">
                              <h5 class="mb-1">Waste Name</h5>
                              <p class="m-0 fw-500 col-fonts-grey">DISTILLATION RESIDUE-20.43-SD24B</p>
                            </div>
                          </CCol>

                          <CCol md="6"> 
                            <div class="w-100">
                              <h5 class="mb-1">Packaging Mode</h5>
                              <p class="m-0 fw-500 col-fonts-grey">Jumbo Bags</p>
                            </div>
                          </CCol>
                        </CCol>

                        <CCol md="12" class="d-flex mb-1"> 
                          <div class="w-100">
                            <h5 class="mb-1">Notification</h5>
                            <p class="m-0 fw-500 col-fonts-grey">Vehicle has been assigned for your request number 00019203. Details are as: John Doe</p>
                          </div>
                        </CCol>

                        <CCol md="12" class="d-flex"> 
                          <div class="w-100">
                             <span class="d-flex align-center col-yellow fw-500 justify-end"><CIcon name="cil-calendar" class="mr-1 h-20 w-20"/> 08 Sep 2020</span>
                          </div>
                        </CCol>

                      </CListGroupItem>
                    </CListGroup>
                </CCard>
              </CCol>

              <CCol md="6">
                <CCard class="m-0">
                    <CListGroup>
                      <CListGroupItem
                        class="flex-column align-items-start pl-0 pr-0"
                      >
                        <CCol md="12" class="d-flex p-0 mb-3"> 
                          <CCol md="6">
                            <div class="w-100">
                              <h5 class="mb-1">Customer Code</h5>
                              <p class="m-0 col-green fw-500">420001783</p>
                            </div>
                          </CCol>

                          <CCol md="6"> 
                            <div class="w-100">
                              <h5 class="mb-1">Customer Name</h5>
                              <p class="m-0 fw-500">John Doe</p>
                            </div>
                          </CCol>
                        </CCol>

                        <CCol md="12" class="d-flex p-0 mb-3"> 
                          <CCol md="6">
                            <div class="w-100">
                              <h5 class="mb-1">Waste Name</h5>
                              <p class="m-0 fw-500 col-fonts-grey">DISTILLATION RESIDUE-20.43-SD24B</p>
                            </div>
                          </CCol>

                          <CCol md="6"> 
                            <div class="w-100">
                              <h5 class="mb-1">Packaging Mode</h5>
                              <p class="m-0 fw-500 col-fonts-grey">Jumbo Bags</p>
                            </div>
                          </CCol>
                        </CCol>

                        <CCol md="12" class="d-flex"> 
                          <div class="w-100">
                            <h5 class="mb-1">Notification</h5>
                            <p class="m-0 fw-500 col-fonts-grey">Vehicle has been assigned for your request number 00019203. Details are as: John Doe</p>
                          </div>
                        </CCol>

                        <CCol md="12" class="d-flex"> 
                          <div class="w-100">
                             <span class="d-flex align-center col-yellow fw-500 justify-end"><CIcon name="cil-calendar" class="mr-1 h-20 w-20"/> 17 Aug 2020</span>
                          </div>
                        </CCol>

                      </CListGroupItem>
                    </CListGroup>
                </CCard>
              </CCol>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>

export default {
  name: 'Notification',
  data () {
    return {	
    }
  },
  mounted () {
	
  },
  computed: {
        
   },
  methods: {
   
  }
}
</script>
